import axios from 'axios';
import pfn from './SubmissionNoteFns.js'
import { toolUtils } from '../../../../utils/toolUtils.js'

export default {
  updateSubmissionNote: async function (payload, props, setFuncMap) {
    try {
      setFuncMap.setIsContentLoading(true)
      if (payload.id) {
        await this.updateSubmissionNoteByIdAction(payload, props.conferenceUid)
      }
      else {
        await this.updateSubmissionNoteAction(payload, props.conferenceUid)
      }
      let res = await pfn.getSubmissionNotesAction(props.conferenceUid)
      setFuncMap.setIsContentLoading(false)
      setFuncMap.setLangSubmissionNote(res.data.find(item => { return item.lang === payload.lang }))
    } catch (error) {
    }
  },
  updateSubmissionNoteAction: (payload, conferenceUid) => {
    return axios({
      method: 'POST',
      url: `/conference/${conferenceUid}/submission-note`,
      headers: {
        "role": "topUser"
      },
      data: payload
    })
  },
  updateSubmissionNoteByIdAction: (payload, conferenceUid) => {
    return axios({
      method: 'POST',
      url: `/conference/${conferenceUid}/submission-note/${payload.id}`,
      headers: {
        "role": "topUser"
      },
      data: payload
    })
  },
  getSubmissionNote: async function (props, setFuncMap) {
    try {
      setFuncMap.setIsContentLoading(true)
      const res = await this.getSubmissionNotesAction(props.conferenceUid)
      let result = {}
      res.data.forEach(item => {
        result[item.lang] = item
      })
      setFuncMap.setSubmissionNoteMap(result)
      setFuncMap.setIsContentLoading(false)
    } catch (error) {
    }
  },
  getSubmissionNoteByIdAction: (conferenceUid) => {
    return axios({
      method: 'GET',
      url: `/conference/${conferenceUid}/submission-note`,
      headers: {
        "role": "topUser"
      }
    })
  },
};
